import React, { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { googleSignOut } from '../../services/AuthService';
import './styles.css';
import menubarImage from "../assets/menubar.png";
import { Link, useNavigate } from 'react-router-dom';

const NavBar = () => {
  const [isResourcesOpen, setResourcesOpen] = useState(false);
  const [isAboutUsOpen, setAboutUsOpen] = useState(false);
  const [isHighSchoolOpen, setHighSchoolOpen] = useState(false);
  const { user, logout, isAuthenticated } = useContext(AuthContext);
  const [dropdown, setDropdown] = useState(null);
  const navigate = useNavigate();

  const handleLoginClick = () => navigate('/login');

  const handleLogout = () => {
    googleSignOut();
    logout();
  };

  const toggleDropdown = (setter, currentState) => {
    setAboutUsOpen(false);
    setHighSchoolOpen(false);
    setResourcesOpen(false);
    setter(!currentState);
  };

  const Arrow = ({ open }) => (
    <span className={`arrow ${open ? 'open' : ''}`}>{open ? '▴' : '▾'}</span>
  );

  return (
    <nav className="navbar" style={{ backgroundImage: `url(${menubarImage})` }}>
      <div className="navbar-content">
        <div className="nav-center">
          {/* About Us Dropdown */}
          <div className={`nav-item-container ${isAboutUsOpen ? 'active' : ''}`}>
            <div className={`nav-item ${isAboutUsOpen ? 'active' : ''}`}>
              <button onClick={() => toggleDropdown(setAboutUsOpen, isAboutUsOpen)}>
                About Us <Arrow open={isAboutUsOpen} />
              </button>
            </div>
            {isAboutUsOpen && (
              <div className="mega-dropdown">
                <div className="mega-dropdown-content">
                  <Link to="/" onClick={() => toggleDropdown(setAboutUsOpen, isAboutUsOpen)}>
                    Our Mission
                  </Link>
                </div>
              </div>
            )}
          </div>

          {/* High School Dropdown */}
          <div className={`nav-item-container ${isHighSchoolOpen ? 'active' : ''}`}>
            <div className={`nav-item ${isHighSchoolOpen ? 'active' : ''}`}>
              <button onClick={() => toggleDropdown(setHighSchoolOpen, isHighSchoolOpen)}>
                High School <Arrow open={isHighSchoolOpen} />
              </button>
            </div>
            {isHighSchoolOpen && (
              <div className="mega-dropdown">
                <div className="mega-dropdown-content">
                  <Link to="/programs" onClick={() => toggleDropdown(setHighSchoolOpen, isHighSchoolOpen)}>High School Programs</Link>
                  <Link to="/scheduler" onClick={() => toggleDropdown(setHighSchoolOpen, isHighSchoolOpen)}>Club Scheduler</Link>
                </div>
              </div>
            )}
          </div>

          {/* Resources Dropdown */}
          <div className={`nav-item-container ${isResourcesOpen ? 'active' : ''}`}>
            <div className={`nav-item ${isResourcesOpen ? 'active' : ''}`}>
              <button onClick={() => toggleDropdown(setResourcesOpen, isResourcesOpen)}>
                Resources <Arrow open={isResourcesOpen} />
              </button>
            </div>
            {isResourcesOpen && (
              <div className="mega-dropdown">
                <div className="mega-dropdown-content">
                  <Link to="/challenges" onClick={() => toggleDropdown(setResourcesOpen, isResourcesOpen)}>Challenge Library</Link>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Profile Section */}
        {isAuthenticated && user ? (
          <div
            className="profile-section"
            onClick={() => setDropdown(dropdown === "profile" ? null : "profile")}
          >
            {user.picture ? (
              <img src={user.picture} alt="Profile" className="profile-image" />
            ) : (
              <div className="profile-initial">
                {user?.username?.charAt(0)?.toUpperCase() || '?'}
              </div>
            )}

            {dropdown === "profile" && (
              <div className="dropdown-menu">
                <ul>
                  <li>{user.username}</li>
                  <li>Account</li>
                  <li>Settings</li>
                  <li onClick={handleLogout}>Logout</li>
                </ul>
              </div>
            )}
          </div>
        ) : (
          <button className="login-button" onClick={handleLoginClick}>Login</button>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
